export const CPS_LOCALE = {
  enGB: 'en-GB',
  plPL: 'pl-PL',
  ro: 'ro-RO',
  et: 'et-EE',
  nl: 'nl-NL',
  fr: 'fr-FR',
  hr: 'hr-HR'
} as const;

export type CpsLocale = (typeof CPS_LOCALE)[keyof typeof CPS_LOCALE];
